// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2T_3y","content":"styles_content__7ecVb","row":"styles_row__2_KyB","footer":"styles_footer__E68bv","phraseLength":"styles_phraseLength__2tven"};